import PropTypes from 'prop-types';
import React from 'react';

const ToggleButton = ({enabled, onClick}) => (
  <input
    className="ToggleButton"
    type="checkbox"
    checked={enabled}
    onChange={() => onClick(!enabled)}
  />
);

ToggleButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/ToggleButton.js